import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useThemeContext, THEME_TYPE_CLASSIC, THEME_TYPE_BLOOMBERG, ThemeType } from '../context/ThemeContext';

const ThemeSwitcher: React.FC = () => {
    const { currentTheme, setTheme } = useThemeContext();

    return (
        <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="theme-select-label">Theme</InputLabel>
            <Select
                labelId="theme-select-label"
                value={currentTheme}
                label="Theme"
                variant="outlined"
                onChange={(e) => setTheme(e.target.value as ThemeType)}
            >
                <MenuItem value={THEME_TYPE_CLASSIC}>Classic</MenuItem>
                <MenuItem value={THEME_TYPE_BLOOMBERG}>Bloomberg</MenuItem>
            </Select>
        </FormControl>
    );
};

export default ThemeSwitcher; 